import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthService} from './auth/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {PromoBannerService} from './share/promo-banner.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {

  routeSubscription: Subscription;
  path: string;

  constructor(
    private authService: AuthService,
    private router: Router,
    private promoBannerService: PromoBannerService
  ) {}

   ngOnInit() {
    this.routeSubscription = this.router.events.subscribe(
      (data:any) => {
        this.path = location.pathname.trim();
      }
    );

   }

  isAuthenticated() {
    return this.authService.isAuthenticated();
  }

  checkViewBanner(): boolean {
    return this.promoBannerService.checkViewBanner();
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
  }
}
